// extracted by mini-css-extract-plugin
export default {"styleCenterAndFixed":"hTbjd5","refreshButton":"EWoRaB"};